import { ModalDialogComponent } from './../../shared/components/modal-dialog/modal-dialog.component';
import { Component, OnInit } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Experts } from './experts.model';
import * as expertsJson from './experts.json';
import * as supportJson from './support.json';
import * as staffJson from './staff.json';

@Component({
    selector: 'app-team',
    templateUrl: './meet-the-team.component.html',
    styleUrls: ['./meet-the-team.component.scss']
})
export class MeetTheTeamComponent implements OnInit {
  modalRef: BsModalRef;
    constructor(private modalService: BsModalService) { }

    ngOnInit(): void { }

    openModal(expert: any) {
      const initialState = {
        name: expert.name,
        title: expert.title,
        message: expert.longDescription,
        qualifications: expert.qualifications,
        memberships: expert.memberships,
        other: expert.other,
        specialInterests: expert.specialInterests,
        experience: expert.experience,
        hasMemberships: expert.hasMemberships,
        hasOther: expert.hasOther,
        hasPublications: expert.hasPublications,
        hasSpecialInterests: expert.hasSpecialInterests,
        publications: expert.publications
    };

      this.modalRef = this.modalService.show(ModalDialogComponent, { initialState });
    }

    experts=expertsJson["team"];
    staff=staffJson["staff"];
    supports=supportJson["support"];

    carouselProperties = {
      autoplay: true
  };

      teamCarousel={
        center: true,
        loop: true,
        dots: true,
        margin: 0,
        responsive: {
            0: {
                items: 2,
                margin: 10
            },
            576: {
                items: 3
            },
            768: {
                items: 4
            },
            1200: {
                items: 6
            }
        }
      }

      trainercarouselOptions= {
        center: true,
        loop: true,
        dots: true,
        margin: 0,
        responsive: {
            0: {
                items: 2,
                margin: 10
            },
            576: {
                items: 3
            },
            768: {
                items: 4
            },
            1200: {
                items: 6
            }
        }
      }
}
